/*! TIRTIR gamified pop-up · designed and built by DISRUPT (https://www.disrupt.co.kr), Seoul */
/* TIRTIR gamified popup - loader.
   Install (theme.liquid, before </body>):
     <script>window.DISRUPT_POPUP={gameAsset:"{{ 'tirtir-game.js' | asset_url }}"};</script>
     (Klaviyo: klaviyoCompany = public site ID, klaviyoList = email list, klaviyoSmsList = SMS list.)
     <script src="{{ 'tirtir-popup.js' | asset_url }}" defer></script>
   The game payload is fetched only on pageviews that are going to show the popup,
   so it costs nothing on the others.

   The game runs in a full-viewport transparent iframe and lays out its own dialog
   (width, height, scrolling), so the popup always hugs the current screen of the game.

   9 Oct 2026: the pop-up also waits for an add to cart on its way and for an open chat, Rewards, gift-offer
   or shade-finder panel, gives the keyboard back to the page when it closes, and the replay tab has a position
   (tabBottom, tabLeft) and steps aside while a drawer or panel is open. More panels to wait for: waitFor
   (CSS selectors).
   The replay tab is an offer, not a fixture (Matt, 9 Oct 2026): see tabCloses and tabStays below.
   10 Oct 2026: no email address or phone number in any dataLayer push or page event any more; waitForPanels
   (false = the pop-up no longer waits for an open chat, Rewards, gift-offer or shade-finder panel); waitForConsent
   (false = it no longer waits for the cookie banner and opens above it); countUrl (an anonymous step counter,
   see count() below; no countUrl = no counter and no request).
   16 Oct 2026: smsTest, an A/B test of the phone reward for US visitors (see the SMS test block below).
   16 Oct 2026: emailNow, the 10% email goes out at once when the visitor says no to the phone offer, closes it, leaves
   the page on it, or gets no phone offer (see the emailNow block below).
*/
(function () {
  "use strict";

  var BUILT_BY = "TIRTIR gamified pop-up · designed and built by DISRUPT (https://www.disrupt.co.kr), Seoul";   // credit for anyone inspecting the code; never shown on the page
  var D = window.DISRUPT_POPUP || {};
  var CFG = {
    enabled:        D.enabled !== false,
    gameAsset:      D.gameAsset      || null,
    delayMs:        D.delayMs        || 4000,
    minDelayMs:     D.minDelayMs     || 3000,
    // Extra triggers, whichever comes first with the timer (Matt, 6 Oct: 3 s felt too fast).
    scrollPercent:  Number(D.scrollPercent) > 0 && Number(D.scrollPercent) <= 100 ? Number(D.scrollPercent) : null,   // open once the visitor scrolls this far (after minDelayMs)
    exitIntent:     D.exitIntent === true,        // desktop only: open when the mouse leaves through the top of the window
    suppressDays:   D.suppressDays   || 7,
    replayTab:      D.replayTab !== false,
    // The tab must not hover for ever (Matt, 9 Oct 2026). It goes for good once the game has been closed
    // tabCloses times in a visit (0 = no limit). With tabStays "visit" it only shows during the visit in which
    // the game was shown and, once the reward is claimed, only until the visitor leaves that page.
    // tabStays "always" = on every page and every visit, as before.
    tabCloses:      px(D.tabCloses, 2),
    tabStays:       D.tabStays === "always" ? "always" : "visit",
    // Where the replay tab sits, px from the bottom and left edge. 150 keeps it clear of this store's free-gift
    // button, chat bubble and sticky add-to-cart bar (at 14 it sat on the gift button and the bar).
    tabBottom:      px(D.tabBottom, 150),
    tabLeft:        px(D.tabLeft, 14),
    waitFor:        Array.isArray(D.waitFor) ? D.waitFor : [],   // CSS selectors of more panels to wait for, e.g. ["#my-app-panel.is-open"]
    // false = the pop-up opens on its normal triggers even while an app panel (chat, Rewards, gift offers, shade
    // finder, waitFor) is open (Matt, 10 Oct 2026, for more leads). Theme drawers, an add to cart on its way and the
    // cookie banner still hold it back either way, and the replay tab still hides while a drawer or panel is open.
    waitForPanels:  D.waitForPanels !== false,
    // false = the pop-up does not wait for Shopify's cookie banner at all (no hold until it is answered, no pause
    // after the answer): it opens on its normal triggers, above the banner (Matt, 10 Oct 2026).
    waitForConsent: D.waitForConsent !== false,
    // Anonymous step counter (10 Oct 2026), see count(). countUrl: where the step notes go; missing or empty =
    // counter off, no request at all. countConsent: true = send only while the store's own consent tool does not
    // say no to analytics. countTest: every note is marked as test traffic.
    countUrl:       typeof D.countUrl === "string" && /^https:\/\//.test(D.countUrl) ? D.countUrl : null,
    countConsent:   D.countConsent !== false,
    countTest:      D.countTest === true,
    alwaysShow:     D.alwaysShow === true,        // test mode: ignore all suppression
    excludePaths:   D.excludePaths   || ["/checkout", "/checkouts", "/cart", "/account", "/password", "/tools"],
    klaviyoCompany: D.klaviyoCompany || null,
    klaviyoList:    D.klaviyoList    || null,
    klaviyoSmsList: D.klaviyoSmsList || null,     // phone numbers join this list with SMS marketing consent
    source:         D.source         || "Gamified popup",
    smsLive:        D.smsLive === true,           // set only when a real service texts the code
    emailNow:       !!(D.emailNow && D.emailNow.on === true && typeof D.emailNow.list === "string" && D.emailNow.list),   // see the emailNow block below
    emailNowList:   D.emailNow && typeof D.emailNow.list === "string" ? D.emailNow.list : null,
    emailNowMaxMs:  (D.emailNow && Number(D.emailNow.maxMinutes) > 0 ? Number(D.emailNow.maxMinutes) : 15) * 6e4,
    debug:          D.debug || /[?&]popupdebug=1/.test(location.search)
  };

  // Version 1 (default): one game, email only.
  // Version 2: after the email (10% code) the winner is offered an upgraded code (15%) for a phone number.
  // Set version:2 in DISRUPT_POPUP. With debug:true in the store config (not the ?popupdebug=1
  // logging switch), ?popupversion=1 or 2 in the URL overrides it for testing.
  // The older second game (pick a cushion for a free sample, then "text me the gift code") is still
  // in the game, switched off: sampleGame:true + phoneStep:true, or ?popupsample=1 when testing.
  var vq = D.debug === true ? /[?&]popupversion=([12])\b/.exec(location.search) : null;
  var sq = D.debug === true && /[?&]popupsample=1\b/.test(location.search);
  var VERSION = vq ? Number(vq[1]) : (D.version === 2 ? 2 : 1);
  var own = function (k, fallback) { return typeof D[k] === "boolean" && !vq && !sq ? D[k] : fallback; };
  var FEATURES = {
    phoneUpgrade: own("phoneUpgrade", !sq && VERSION === 2),
    sampleGame:   own("sampleGame", sq),
    phoneStep:    own("phoneStep", sq),
    winPercent:     Number(D.winPercent) > 0 ? Number(D.winPercent) : 10,
    upgradePercent: Number(D.upgradePercent) > 0 ? Number(D.upgradePercent) : 15
  };

  // Phone numbers are collected from US and Canada visitors only (Canada since 7 Oct 2026). On a real store (debug off) the offer is
  // skipped when Shopify reports another country; those visitors get the email-only flow.
  // Shopify.country is the visitor's country as Shopify sees it (location and their country selector).
  // Real store (debug off): the phone offer shows ONLY when that country is in the list; if Shopify
  // gives no country, it is hidden. Staging (debug:true): always shown, unless ?popupcountry=XX is
  // added to try another country.
  var cq = D.debug === true ? /[?&]popupcountry=([A-Za-z]{2})\b/.exec(location.search) : null;
  var country = cq ? cq[1].toUpperCase() : (window.Shopify && window.Shopify.country ? String(window.Shopify.country).toUpperCase() : null);
  var phoneCountries = D.phoneCountries || ["US", "CA"];   // Canada added 7 Oct 2026 (TIRTIR confirmed)
  if ((D.debug !== true || cq) && phoneCountries.indexOf(country) === -1) { FEATURES.phoneUpgrade = false; FEATURES.phoneStep = false; }
  FEATURES.country = country;

  // Sharing: the card links back to this store, and a visitor arriving on a shared link
  // (?beatMs=13430) is shown "Can you beat 13.43s?".
  var bq = /[?&]beatMs=(\d{3,7})\b/.exec(location.search);
  var bn = bq ? Number(bq[1]) : 0;
  FEATURES.beatMs = bn >= 500 && bn <= 3600000 ? bn : null;   // same bounds as the game
  FEATURES.shareUrl = D.shareUrl || (location.origin + "/");

  // SMS test (Matt, 16 Oct 2026: "lets test us first than"): smsTest in DISRUPT_POPUP, for example
  // { on: true, countries: ["US"], b: { amount: 20, min: 70, symbol: "$" } }. Only for a visitor whose country is in
  // smsTest.countries and who gets the phone offer. Version A = the upgradePercent code (15%), as before; version B =
  // b.amount off orders of b.min or more ($20 off $70+). 50/50 (Math.random), drawn the first time the offer is about
  // to show, kept in localStorage (K_SMS_AB) so the visitor keeps it on later visits (storage blocked: for this page
  // only); never drawn again. The game gets it as TIRTIR_CONFIG.smsOffer, the Klaviyo profile as tirtir_popup_sms_ab
  // ("A" / "B") and tirtir_popup_sms_offer ("15%" / "$20 off $70+"), the counter as offer_a / offer_b and phone_a /
  // phone_b (on top of offer and phone, so each version is counted from its own steps). Everyone else: none of this
  // runs, nothing is stored, no extra request, every request as before. on: false = everyone gets version A, as
  // before the test, and no _a / _b notes.
  // With debug:true in the store config, ?popupsms=a or ?popupsms=b forces a version for testing (nothing stored).
  var T = D.smsTest || {}, TB = T.b || {};
  var SMS_AB = T.on === true && Array.isArray(T.countries) && T.countries.indexOf(country) !== -1 && FEATURES.phoneUpgrade === true &&
    Number(TB.amount) > 0 && Number(TB.min) > 0;
  var smsForced = SMS_AB && D.debug === true ? (/[?&]popupsms=([ab])\b/i.exec(location.search) || [])[1] : null;
  var K_SMS_AB = "tirtir_popup_sms_ab", smsDrawn = null;
  // When this browser first saw the phone offer (ISO, UTC), for the dashboard's 14-day window per person: stored the
  // first time and sent unchanged after that (tirtir_popup_sms_ab_at, next to tirtir_popup_sms_ab). Forced versions and
  // blocked storage: the time of this page.
  var K_SMS_AB_AT = "tirtir_popup_sms_ab_at", smsAtPage = null;
  function smsAt() {
    if (smsAtPage) return smsAtPage;
    var t = smsForced ? null : get(K_SMS_AB_AT);
    if (t && /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?Z$/.test(t)) return (smsAtPage = t);
    t = new Date().toISOString();
    if (!smsForced) set(K_SMS_AB_AT, t);
    return (smsAtPage = t);
  }
  // The visitor's version, "A" or "B"; null if none was drawn yet and draw is false. Called only when SMS_AB.
  // With the email (the claim), the version comes from the address itself, so the same person gets the same version in
  // every browser (an Instagram in-app browser, then Safari from the email link). Half the addresses are A, half B. No
  // email (an offer reopened on a later page): Math.random. A version stored in this browser always wins.
  function smsVersion(draw, email) {
    if (smsForced) return smsForced.toUpperCase();
    if (smsDrawn) return smsDrawn;
    var v = get(K_SMS_AB);
    if (v === "A" || v === "B") return (smsDrawn = v);
    if (!draw) return null;
    smsDrawn = email ? (emailBit(email) ? "B" : "A") : Math.random() < 0.5 ? "A" : "B";
    set(K_SMS_AB, smsDrawn);
    return smsDrawn;
  }
  // FNV-1a over the trimmed, lowercased address (Klaviyo stores addresses in lower case); 0 or 1. Only computed here.
  function emailBit(email) {
    var e = String(email).replace(/^\s+|\s+$/g, "").toLowerCase(), h = 0x811c9dc5;
    for (var i = 0; i < e.length; i++) { h ^= e.charCodeAt(i); h = (h + (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24)) >>> 0; }
    return (h >>> 16) & 1;
  }
  // Hands the version to the game: in the config written into it, or, once the game is built, into that config
  // itself (the game reads it when it draws the offer and the final screen).
  function smsGive(v) {
    var b = v === "B";
    FEATURES.smsOffer = { variant: b ? "B" : "A", kind: b ? "amount" : "pct", value: b ? Number(TB.amount) : FEATURES.upgradePercent, min: b ? Number(TB.min) : null, symbol: String(TB.symbol || "$") };
    try { var w = frame && frame.contentWindow; if (w && w.TIRTIR_CONFIG) w.TIRTIR_CONFIG.smsOffer = w.JSON.parse(JSON.stringify(FEATURES.smsOffer)); } catch (e) {}
  }
  function smsLabel() { var o = FEATURES.smsOffer; return o.kind === "amount" ? o.symbol + o.value + " off " + o.symbol + o.min + "+" : o.value + "%"; }
  function smsStep(step) { return SMS_AB && FEATURES.smsOffer ? step + "_" + FEATURES.smsOffer.variant.toLowerCase() : null; }   // offer_a, phone_b, ...

  var K_DISMISS = "tirtir_popup_dismissed_until";
  var K_WON     = "tirtir_popup_won";
  var K_SHOWN   = "tirtir_popup_shown_session";
  var K_CLOSES  = "tirtir_popup_closes_session";   // how often the game has been closed in this visit
  var K_CHAL    = "tirtir_popup_challenge";        // the beatMs already shown in this tab
  var K_RESULT  = "tirtir_popup_result_session";   // this visit's win, so it can be shared from any page
  function challengeSeen() { try { return sessionStorage.getItem(K_CHAL) === String(FEATURES.beatMs); } catch (e) { return false; } }
  function saveResult(ms, claimed, upgrade) { try { sessionStorage.setItem(K_RESULT, JSON.stringify({ ms: ms, claimed: claimed, upgrade: upgrade || null })); } catch (e) {} }
  // Version 1 only: on a later page in the same visit, bring back the win (time, claimed or not) so
  // the tab still leads to the reward and "Share my result". No email is stored. Off in test mode,
  // where every load starts a fresh game, and off for a challenge link seen for the first time.
  (function () {
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(K_RESULT) || "null"); } catch (e) {}
    if (saved && !CFG.alwaysShow && !FEATURES.sampleGame && !(FEATURES.beatMs && !challengeSeen()) && saved.ms >= 500 && saved.ms <= 3600000)
      FEATURES.restore = { elapsedMs: Number(saved.ms), claimed: saved.claimed === true, upgrade: saved.upgrade === "upgraded" || saved.upgrade === "declined" ? saved.upgrade : null };
  })();
  var EMAIL_RE  = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function px(v, fallback) { var n = Number(v); return v !== null && v !== undefined && v !== "" && isFinite(n) && n >= 0 ? Math.round(n) : fallback; }
  function log() { if (CFG.debug) try { console.log.apply(console, ["[tirtir-popup]"].concat([].slice.call(arguments))); } catch (e) {} }
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  // Matches whole path segments, so /cart and /en-us/cart are excluded but /collections/cartoon is not.
  function excluded() {
    var p = ((location.pathname || "").toLowerCase().replace(/\/+$/, "")) + "/";
    for (var i = 0; i < CFG.excludePaths.length; i++) {
      var x = String(CFG.excludePaths[i]).toLowerCase().replace(/\/+$/, "") + "/";
      if (p.indexOf(x) !== -1) return CFG.excludePaths[i];
    }
    return false;
  }
  function blocked() {
    if (!CFG.enabled) return "disabled";
    if (window.Shopify && window.Shopify.designMode) return "theme editor";
    if (!window.HTMLDialogElement || typeof window.HTMLDialogElement.prototype.showModal !== "function") return "no dialog support";
    var ex = excluded();
    return ex ? "excluded path " + ex : false;
  }
  function suppressedUntil() {
    var u = Number(get(K_DISMISS) || 0);
    return u && Date.now() < u ? u : 0;
  }
  function shouldAutoShow() {
    if (CFG.alwaysShow) { log("test mode: always show"); return true; }
    if (FEATURES.beatMs && !challengeSeen()) { log("challenge link: show"); return true; }
    if (get(K_WON))     { log("already won"); return false; }
    var s = suppressedUntil();
    if (s)              { log("suppressed until", new Date(s).toISOString()); return false; }
    try { if (sessionStorage.getItem(K_SHOWN)) { log("already shown this session"); return false; } } catch (e) {}
    return true;
  }

  function closes() { try { return Number(sessionStorage.getItem(K_CLOSES) || 0); } catch (e) { return 0; } }
  // May the replay tab show? atLoad: on arriving at a page, as opposed to right after closing the game on it.
  function tabAllowed(atLoad) {
    if (!CFG.replayTab) return false;
    if (CFG.tabCloses && closes() >= CFG.tabCloses) return false;
    if (CFG.tabStays === "always" || !atLoad) return true;
    if (get(K_WON)) return false;                                                    // claimed: the tab stayed on that page only
    try { return !!sessionStorage.getItem(K_SHOWN); } catch (e) { return false; }   // only in the visit that saw the game
  }

  /* ---------- anonymous step counter ---------- */
  // One tiny note per funnel step to DISRUPT's counting address, for example {"v":1,"s":["seen"]}. Steps: seen,
  // again, tried, round, won, email, email_nowin, offer, phone, card, save, share (SMS test: offer_a, offer_b, phone_a, phone_b). Nothing else is in it: no email, phone, id, cookie, page address,
  // time or game result. Each step goes at most once per page load (sent) and, through the pop-up's own flags, once
  // per visit; the counter stores nothing itself. Never waited for, the answer is never read, every error is
  // swallowed: the pop-up is the same with the counter on, off or unreachable. Kept apart from emit().
  var sent = {}, storeOk = false, openAuto = false, openFirst = false;
  var countMode = (/[?&]popupcount=(off|test)\b/.exec(location.search) || [])[1];   // ?popupcount=off / =test, for our own checks
  function count(steps) {
    try {
      if (!CFG.countUrl || !window.fetch || !storeOk || CFG.alwaysShow || countMode === "off") return;
      var n = window.navigator || {}, S = window.Shopify || {}, cp = S.customerPrivacy, out = [], i;
      if (n.webdriver === true || n.globalPrivacyControl === true) return;                    // automation; Global Privacy Control
      if (S.designMode || (S.theme && S.theme.role && S.theme.role !== "main")) return;       // theme editor; theme preview
      if (CFG.countConsent && cp && typeof cp.analyticsProcessingAllowed === "function" && cp.analyticsProcessingAllowed() === false) return;
      for (i = 0; i < steps.length; i++) if (!sent[steps[i]]) { sent[steps[i]] = 1; out.push(steps[i]); }
      if (!out.length) return;
      if (CFG.debug) { log("count, not sent while debug is on:", out.join("+")); return; }
      var note = { v: 1, s: out };
      if (CFG.countTest || countMode === "test") note.x = 1;
      fetch(CFG.countUrl, { method: "POST", body: JSON.stringify(note), mode: "cors", credentials: "omit",
        referrerPolicy: "no-referrer", keepalive: true, cache: "no-store" }).catch(function () {});
    } catch (e) {}
  }
  // Two steps the game does not report by message (10 Oct 2026): "tried" = the first press on "Hold to sneak" has
  // started a round (the game marks it with data-phase="running"), "offer" = the phone offer screen is on screen
  // (data-screen="sh-upgrade"). Both are read from the game's own markers with an observer: it only listens, so it
  // cannot block or delay a press. Once per page load each. The round markers change on every frame of play, so
  // they are watched only until the first press; without a counter address nothing is watched at all.
  // Result card (10 Oct 2026): "card" = the card screen is on screen (data-screen starts with "sq-card-view"),
  // "save" = "Save image" was pressed, "share" = "Share" was pressed (the press is counted, whatever follows).
  // The two presses are heard by one passive click listener on the game's document; it never blocks a press.
  var gameObs = null, triedSeen = false, offerSeen = !FEATURES.phoneUpgrade, cardSeen = false, pressHeard = false;   // no phone offer for this visitor: nothing to wait for
  function gamePress(e) {
    try {
      var b = open_ && e.target && e.target.closest ? e.target.closest("#sh-save, #sh-share") : null;
      if (b) count([b.id === "sh-save" ? "save" : "share"]);
    } catch (err) {}
  }
  function gameSteps() {
    try {
      if (!open_ || !frame) return;
      var d = frame.contentDocument, p = d.getElementById("popup"), g = triedSeen ? null : d.querySelector(".puff-heist");
      if (g && g.getAttribute("data-phase") === "running") { triedSeen = true; count(["tried"]); watchGame(); }
      if (!offerSeen && p && p.getAttribute("data-screen") === "sh-upgrade") { offerSeen = true; count(["offer"]); if (SMS_AB) smsShown(); watchGame(); }
      if (!cardSeen && p && String(p.getAttribute("data-screen") || "").indexOf("sq-card-view") === 0) { cardSeen = true; count(["card"]); watchGame(); }
    } catch (e) {}
  }
  function watchGame() {
    try {
      if (gameObs) { gameObs.disconnect(); gameObs = null; }
      if (!CFG.countUrl && !SMS_AB) return;   // SMS test: the offer screen is watched for the profile update even without a counter
      if (!pressHeard) { frame.contentDocument.addEventListener("click", gamePress, { capture: true, passive: true }); pressHeard = true; }
      if (triedSeen && offerSeen && cardSeen) return;
      var p = frame.contentDocument.getElementById("popup");
      if (!p) return;
      gameObs = new MutationObserver(gameSteps);
      gameObs.observe(p, triedSeen ? { attributes: true, attributeFilter: ["data-screen"] }
                                   : { attributes: true, subtree: true, attributeFilter: ["data-phase", "data-screen"] });
    } catch (e) {}
  }
  // SMS test: the phone offer is on screen. The version is also counted on its own (offer_a / offer_b, a separate note,
  // so a counter that does not know these names yet still counts offer), and goes on the person's profile, as
  // saveSample does.
  function smsShown() {
    if (!FEATURES.smsOffer) return;
    count([smsStep("offer")]);
    if (!lastLead || !CFG.klaviyoCompany || !CFG.klaviyoList) return;
    klaviyo("profiles", { data: { type: "profile", attributes: { email: lastLead.email, properties: { tirtir_popup_sms_ab: FEATURES.smsOffer.variant, tirtir_popup_sms_offer: smsLabel(), tirtir_popup_sms_ab_at: smsAt() } } } },
      function (err) { log("sms test version saved:", !err); });
  }
  function upgradedBefore() { try { return (JSON.parse(sessionStorage.getItem(K_RESULT) || "null") || {}).upgrade === "upgraded"; } catch (e) { return false; } }

  /* ---------- is something else open on the page? ---------- */
  // Panels the pop-up must not cover and the tab must not sit on: the theme's cart drawer, menu, filters or
  // quick-add (Broadcast sets data-scroll-locked), the chat window (Channel Talk), the Rewards panel (Okendo),
  // the free-gift offers list (BOGOS) and the shade finder. Checked on the live store 9 Oct 2026: each one is
  // on screen only while its panel is open.
  var PANELS = ["#ch-plugin-script:not(.ch-messenger-hidden)", ".okeLoyalty--floatingWidget #oke-rewards-widget", "#sca-today-offer-wrap", "#mmm-widget-container.mmm-active"].concat(CFG.waitFor);
  function onScreen(el) {
    if (!el || !el.getClientRects().length) return false;
    var r = el.getBoundingClientRect(), cs = window.getComputedStyle(el);
    return r.width >= 100 && r.height >= 100 && r.bottom > 0 && r.right > 0 && r.top < window.innerHeight && r.left < window.innerWidth &&
      cs.visibility !== "hidden" && cs.opacity !== "0";
  }
  function themeLocked() { return document.documentElement.hasAttribute("data-scroll-locked"); }
  function appPanel() {   // the selector of an app panel that is open, or null
    for (var i = 0; i < PANELS.length; i++) { try { if (onScreen(document.querySelector(PANELS[i]))) return PANELS[i]; } catch (e) {} }
    return null;
  }
  function panelOpen() { return themeLocked() || !!appPanel(); }
  // An add to cart on its way: the theme opens the cart drawer about 1.5 s after the tap (data-scroll-locked
  // only shows once it is open), so the page counts as busy for 3 s from the tap. On a slow connection the
  // theme keeps is-loading on the button until the answer is back; the drawer follows about half a second later.
  // The listeners only look.
  var CART_WAIT = 3000, cartTapAt = 0, cartUntil = 0;
  function cartTap(e) {
    try {
      var t = e.target;
      if (e.type === "submit" ? t && t.matches && t.matches('form[action*="/cart/add"]')
                              : t && t.closest && t.closest('button[name="add"], form[action*="/cart/add"] [type="submit"]')) {
        cartTapAt = Date.now(); cartUntil = cartTapAt + CART_WAIT;
      }
    } catch (err) {}
  }
  function cartBusy() {
    var now = Date.now();
    try { if (now - cartTapAt < 20000 && document.querySelector('button[name="add"].is-loading')) cartUntil = Math.max(cartUntil, now + 1500); } catch (e) {}
    return now < cartUntil;
  }

  /* ---------- lazy load of the game payload ---------- */
  var loading = null;
  function loadGame() {
    if (window.TIRTIR_GAME_HTML) return Promise.resolve(window.TIRTIR_GAME_HTML);
    if (loading) return loading;
    if (!CFG.gameAsset) return Promise.reject(new Error("no gameAsset configured"));
    loading = new Promise(function (res, rej) {
      var s = document.createElement("script");
      s.src = CFG.gameAsset;
      s.async = true;
      s.onload = function () { window.TIRTIR_GAME_HTML ? res(window.TIRTIR_GAME_HTML) : rej(new Error("asset loaded but payload missing")); };
      s.onerror = function () { loading = null; rej(new Error("failed to load game asset")); };
      document.head.appendChild(s);
    });
    return loading;
  }

  /* ---------- UI ---------- */
  var overlay = null, frame = null, tab = null;
  var open_ = false, ready = false, lastLead = null;
  var wonHere = !!FEATURES.restore, claimedHere = !!(FEATURES.restore && FEATURES.restore.claimed), lastWinMs = FEATURES.restore ? FEATURES.restore.elapsedMs : 0;
  var hideTimer = 0, readyTimer = 0, liveTimer = 0, revealTries = 0, lastFocus = null, savedOverflow = null;
  var autoCovered = null;                         // boot() sets it: the test the timer, scroll and exit triggers use
  var pendingAuto = null, holdTimer = 0, resumed = false;   // an automatic open that is built but not shown yet

  // Gotham Medium, letters only (about 4 KB), for the replay tab. Generated by build_fonts.py.
  // Licence: needs a Gotham web licence before use on a public store.
  var TAB_FONT = "data:font/woff2;base64,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";

  function css() {
    var s = document.createElement("style");
    s.textContent = [
      "@font-face{font-family:TirtirGothamTab;src:url('" + TAB_FONT + "') format('woff2');font-weight:400 700;font-display:swap}",
      ".tp-ovl{position:fixed;left:0;top:0;width:100%;height:100%;z-index:2147483000;margin:0;padding:0;",
      "background:rgba(32,20,14,.55);opacity:0;transition:opacity .25s ease;overscroll-behavior:contain}",
      ".tp-ovl{pointer-events:none}",                    // never block the page while fading out
      ".tp-ovl.tp-on{opacity:1;pointer-events:auto}",
      ".tp-ovl[hidden]{display:none!important}",
      ".tp-ovl iframe{position:absolute;left:0;top:0;width:100%;height:100%;border:0;margin:0;padding:0;display:block;",
      "background:transparent;color-scheme:light}",
      ".tp-ovl iframe{pointer-events:none}.tp-ovl.tp-live iframe{pointer-events:auto}",
      ".tp-tab{position:fixed;left:" + CFG.tabLeft + "px;bottom:" + CFG.tabBottom + "px;z-index:2147482900;border:0;border-radius:999px;padding:12px 17px;",
      "min-height:44px;background:#a9372c;color:#fff;font:500 13px/1 TirtirGothamTab,Gotham,Arial,Helvetica,sans-serif;cursor:pointer;",
      "box-shadow:0 6px 18px rgba(120,40,30,.35);-webkit-tap-highlight-color:transparent}",
      ".tp-tab:focus-visible{outline:2px solid #331a24;outline-offset:3px}",
      ".tp-tab.tp-away{display:none!important}",        // a drawer or panel is open
      "@media(prefers-reduced-motion:reduce){.tp-ovl{transition:none}}"
    ].join("");
    document.head.appendChild(s);
  }

  function send(msg) {
    try { if (frame && frame.contentWindow) frame.contentWindow.postMessage(Object.assign({ __tirtir: 1 }, msg), "*"); } catch (e) {}
  }

  // Keep the game inside the visible area when a phone keyboard opens.
  function fit() {
    if (!overlay) return;
    var vv = window.visualViewport;
    var keyboard = vv && Math.abs(vv.scale - 1) < 0.02 && window.innerHeight - vv.height > 120;
    overlay.style.height = keyboard ? Math.round(vv.height) + "px" : "";
    overlay.style.top = keyboard ? Math.round(vv.offsetTop) + "px" : "";
  }

  function lockScroll(on) {
    var el = document.documentElement;
    if (on) {
      if (savedOverflow === null) savedOverflow = { o: el.style.overflow, p: el.style.paddingRight };
      var gap = window.innerWidth - el.clientWidth;
      el.style.overflow = "hidden";
      if (gap > 0) el.style.paddingRight = gap + "px";
    } else if (savedOverflow !== null) {
      el.style.overflow = savedOverflow.o;
      el.style.paddingRight = savedOverflow.p;
      savedOverflow = null;
    }
  }

  function gameUp() {
    try { var p = frame.contentDocument.getElementById("popup"); return !!(p && p.open); } catch (e) { return false; }
  }
  // Give the game keyboard focus without losing the element it focused itself. Focusing an iframe
  // from the page resets focus inside the frame to <body>, which dropped the heading on every open.
  function focusGame() {
    var doc = null, keep = null;
    try { doc = frame.contentDocument; keep = doc.activeElement; } catch (e) {}
    try { if (doc && keep && keep !== doc.body && doc.hasFocus()) return; } catch (e) {}
    try { frame.focus({ preventScroll: true }); } catch (e) {}
    try {
      if (!keep || keep === doc.body || !doc.contains(keep)) keep = doc.getElementById("popup-title");
      if (keep && doc.activeElement !== keep) keep.focus({ preventScroll: true });
    } catch (e) {}
  }
  // Dim the page only once the game's dialog is really open. If it never opens (script error,
  // blocked inline script) give up quietly instead of leaving the store dimmed and locked.
  function reveal() {
    if (!open_ || !overlay) return;
    clearTimeout(readyTimer);
    if (!gameUp()) {
      if (++revealTries > 60) { revealTries = 0; close("game-failed"); return; }
      readyTimer = setTimeout(reveal, 50);
      return;
    }
    revealTries = 0;
    // An automatic open looks once more: an add to cart, a drawer or a panel may have started while the game was loading.
    if (pendingAuto && autoCovered && autoCovered()) { postpone(); return; }
    pending(null);
    overlay.classList.add("tp-on");
    if (!openAuto) count(["again"]); else if (openFirst) count(["seen"]);   // seen: the automatic pop-up, first time in this visit
    if (!gameObs) watchGame();
    gameSteps();
    focusGame();
    clearTimeout(liveTimer);
    liveTimer = setTimeout(function () {
      if (!open_ || !overlay) return;
      overlay.classList.add("tp-live");
      focusGame();   // the game's win hand-off needs focus inside
    }, 400);
  }

  // While an automatic open is built but not shown, remember what the visitor focuses on the page: the game takes
  // the keyboard as soon as it is built, and a step back must hand it to that field again, not to the page.
  function noteFocus(e) {
    var t = e.target;
    if (pendingAuto && t && t !== frame && t !== document.body && !(overlay && overlay.contains(t))) lastFocus = t;
  }
  function pending(reason) {
    pendingAuto = reason || null;
    try { document[reason ? "addEventListener" : "removeEventListener"]("focusin", noteFocus, true); } catch (e) {}
  }

  // Step back from an automatic open that has not been shown: no close is counted, nothing is remembered, and it
  // tries again once the page is free.
  function postpone() {
    var reason = pendingAuto;
    pending(null); open_ = false;
    log("holding: the page is busy");
    clearTimeout(readyTimer); clearTimeout(liveTimer);
    document.removeEventListener("keydown", esc);
    send({ type: "tirtir:close-request" });   // the game starts fresh when it is shown, as after the tab
    if (overlay) { overlay.classList.remove("tp-on", "tp-live"); overlay.hidden = true; }
    lockScroll(false);
    try { sessionStorage.removeItem(K_SHOWN); if (FEATURES.beatMs) sessionStorage.removeItem(K_CHAL); } catch (e) {}
    restoreFocus();
    (function again() {
      holdTimer = setTimeout(function () {
        if (open_) return;
        if (autoCovered && autoCovered()) { again(); return; }
        resumed = true; open(reason, true);
      }, 1000);
    })();
  }

  // Give the keyboard back to the page. The hidden frame used to keep it: the next key press went nowhere and
  // Tab started at the replay tab.
  function restoreFocus() {
    var back = lastFocus;
    lastFocus = null;
    try { if (frame && document.activeElement === frame) frame.blur(); } catch (e) {}
    try {
      if (back && back !== document.body && back.focus && document.contains(back)) {
        back.focus({ preventScroll: true });
        if (document.activeElement === back) return;
      }
    } catch (e) {}
    // Nothing had focus before (or it is gone): leave it on the page itself, so Tab starts at the top as on a fresh page.
    try {
      var b = document.body, was = b.getAttribute("tabindex"), x = window.pageXOffset, y = window.pageYOffset;
      b.setAttribute("tabindex", "-1");
      b.focus({ preventScroll: true });
      if (was === null) b.removeAttribute("tabindex"); else b.setAttribute("tabindex", was);
      if (window.pageXOffset !== x || window.pageYOffset !== y) window.scrollTo(x, y);   // browsers without preventScroll
    } catch (e) {}
  }

  function build(html) {
    overlay = document.createElement("div");
    overlay.className = "tp-ovl";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-label", "Play to win a reward");
    overlay.setAttribute("data-built-by", BUILT_BY);

    frame = document.createElement("iframe");
    frame.title = "TIRTIR game";
    frame.setAttribute("allow", "clipboard-write");   // srcdoc is same-origin, so sharing needs no extra grant
    frame.setAttribute("allowtransparency", "true");
    // SMS test: a version drawn earlier goes in now; a reward claimed on an earlier page whose offer is still open
    // shows that offer as soon as the game opens, so its version is drawn now.
    if (SMS_AB && !FEATURES.smsOffer) { var sv = smsVersion(!!(FEATURES.restore && FEATURES.restore.claimed && !FEATURES.restore.upgrade)); if (sv) smsGive(sv); }
    // Hand the version switches to the game before any of its scripts run.
    var cfg = JSON.stringify(FEATURES).replace(/</g, "\\u003c");
    frame.srcdoc = html.replace("<head>", function () { return "<head><script>window.TIRTIR_CONFIG=" + cfg + ";<\/script>"; });

    overlay.appendChild(frame);
    document.body.appendChild(overlay);
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", fit);
      window.visualViewport.addEventListener("scroll", fit);
    }
  }

  function open(reason, auto) {
    if (open_) return;
    var why = blocked();
    if (why) { log("not opening:", why); return; }
    clearTimeout(holdTimer);
    var again = resumed;   // coming back from a hold: the open was already reported
    resumed = false;
    open_ = true;
    log("opening:", reason);
    loadGame().then(function (html) {
      if (!open_) return;
      var shownBefore = false;
      try { shownBefore = sessionStorage.getItem(K_SHOWN) === "1"; } catch (e) {}
      try { sessionStorage.setItem(K_SHOWN, "1"); if (FEATURES.beatMs) sessionStorage.setItem(K_CHAL, String(FEATURES.beatMs)); } catch (e) {}
      try { storeOk = sessionStorage.getItem(K_SHOWN) === "1"; } catch (e) { storeOk = false; }   // storage blocked: the counter stays silent
      openAuto = !!auto; openFirst = !shownBefore;
      clearTimeout(hideTimer);
      revealTries = 0;
      lastFocus = document.activeElement;
      pending(auto ? reason : null);
      lockScroll(true);
      if (tab) { tab.style.display = "none"; unwatchTab(); }
      document.addEventListener("keydown", esc);
      if (!overlay) {
        build(html);
        // Fade in once the game says it is ready; never wait longer than 2s.
        readyTimer = setTimeout(reveal, 2000);
      } else {
        overlay.hidden = false;
        send({ type: "tirtir:open" });
        requestAnimationFrame(reveal);
      }
      fit();
      if (!again) emit("open", { reason: reason });
    }).catch(function (err) { open_ = false; log("open failed:", err.message); });
  }

  function esc(e) { if (e.key === "Escape") close("escape"); }

  function close(reason) {
    if (!open_) return;
    open_ = false; pending(null);
    log("close:", reason);
    if (mailOffer) emailNow("closed");
    clearTimeout(readyTimer);
    document.removeEventListener("keydown", esc);
    if (reason !== "game") send({ type: "tirtir:close-request" });   // let the game stop its timer and clear inputs
    if (overlay) {
      clearTimeout(liveTimer);
      overlay.classList.remove("tp-on", "tp-live");
      hideTimer = setTimeout(function () {
        if (open_ || !overlay) return;
        overlay.hidden = true;
        try { if (document.activeElement === frame) frame.blur(); } catch (e) {}
      }, 260);
    }
    lockScroll(false);
    if (!get(K_WON)) set(K_DISMISS, String(Date.now() + CFG.suppressDays * 864e5));
    if (reason !== "game-failed") {
      try { sessionStorage.setItem(K_CLOSES, String(closes() + 1)); } catch (e) {}
      if (tabAllowed(false)) showTab();   // otherwise it stays hidden, as open() left it
    }
    restoreFocus();
    emit("close", { reason: reason });
  }

  function showTab() {
    if (!tab) {
      tab = document.createElement("button");
      tab.className = "tp-tab"; tab.type = "button";
      tab.onclick = function () { open("tab"); };
      document.body.appendChild(tab);
    }
    // Version 1 keeps the win for the rest of the visit (K_RESULT); otherwise a later page starts a new game.
    var upgrade = wonHere && lastLead && lastLead.tier !== "winner";   // claimed by skipping, then won: the win is not claimed yet
    tab.textContent = claimedHere && !upgrade ? "See your reward" : wonHere ? "Claim your reward" : "Play again";
    tab.style.display = "";
    watchTab();
  }

  // The tab steps aside while a theme drawer or one of the PANELS is open, so it never sits on their buttons.
  var tabTimer = 0, tabObs = null;
  function tabSync() { if (tab) tab.classList.toggle("tp-away", panelOpen()); }
  function watchTab() {
    tabSync();
    if (tabTimer) return;
    tabTimer = setInterval(function () { if (tab && tab.style.display !== "none" && !document.hidden) tabSync(); }, 400);
    // Theme drawers and the Rewards panel mark <html>, so those are seen at once.
    try { tabObs = new MutationObserver(tabSync); tabObs.observe(document.documentElement, { attributes: true, attributeFilter: ["data-scroll-locked", "class"] }); } catch (e) {}
  }
  // No tab on the page (the game is open, or the tab is gone for good): nothing to watch.
  function unwatchTab() {
    clearInterval(tabTimer); tabTimer = 0;
    try { if (tabObs) tabObs.disconnect(); } catch (e) {}
    tabObs = null;
  }

  /* ---------- Klaviyo ---------- */
  function subscribe(lead, cb) {
    if (!CFG.klaviyoCompany || !CFG.klaviyoList) {
      log("KLAVIYO NOT CONFIGURED - would subscribe:", { email: lead.email, consent: lead.consent, tier: lead.tier, source: CFG.source });
      return cb(null, { simulated: true });
    }
    var profile = { email: lead.email, properties: { tirtir_popup_reward: lead.tier || "unknown" } };
    if (lead.consent) profile.subscriptions = { email: { marketing: { consent: "SUBSCRIBED" } } };
    var body = { data: { type: "subscription", attributes: {
      custom_source: CFG.source,
      profile: { data: { type: "profile", attributes: profile } }
    }, relationships: { list: { data: { type: "list", id: CFG.klaviyoList } } } } };
    klaviyo("subscriptions", body, cb);
  }

  // The game gives up on a claim after 12 s, so this call must fail before that.
  // keep: the page is being left (pagehide), so the browser is asked to finish the call after the page is gone.
  function klaviyo(endpoint, body, cb, keep) {
    var ctrl = !keep && typeof AbortController === "function" ? new AbortController() : null;
    var giveUp = setTimeout(function () { if (ctrl) ctrl.abort(); }, 10000);
    fetch("https://a.klaviyo.com/client/" + endpoint + "/?company_id=" + encodeURIComponent(CFG.klaviyoCompany), {
      method: "POST",
      headers: { "content-type": "application/json", revision: "2026-07-15" },   // the subscriptions (consent) field needs 2025-01-15 or later
      body: JSON.stringify(body),
      keepalive: keep === true,
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) { clearTimeout(giveUp); log("klaviyo", endpoint, "status", r.status); cb(r.ok ? null : new Error("klaviyo " + r.status), { status: r.status }); })
      .catch(function (e) { clearTimeout(giveUp); log("klaviyo", endpoint, "error", e); cb(e); });
  }

  // QA 5: record which sample was won, so the email flow can honour it.
  function saveSample(gift) {
    emit("sample", { giftId: gift });
    if (!lastLead) return;
    if (!CFG.klaviyoCompany || !CFG.klaviyoList) { log("KLAVIYO NOT CONFIGURED - would save sample:", gift); return; }
    klaviyo("profiles", { data: { type: "profile", attributes: { email: lastLead.email, properties: { tirtir_popup_sample: gift } } } },
      function (err) { log("sample saved:", !err); });
  }

  // emailNow (Matt, 16 Oct 2026: "can we not do if they close or say no thanks shop now they get email immediately? if
  // they put number in they dont"). The 10% email flow waits after the email claim, so a phone number given in that time
  // can stop it. With emailNow on, the pop-up adds the person to a second email list (emailNow.list, "[DISRUPT] POP UP
  // EMAIL NOW") the moment the 10% email can go; that list starts the instant copy of the welcome flow, with no wait.
  // Same consent and source as the email claim itself; the profile gets tirtir_popup_email_now = the reason.
  //   - email claimed and no phone offer follows (not a winner, or no phone offer in this country): at once, "no_offer"
  //   - "No thanks" on the phone offer: "declined"
  //   - the pop-up closed while the phone offer is still open: "closed"
  //   - the page left or hidden while the phone offer is still open (pagehide / visibilitychange, keepalive): "left"
  //   - the pop-up closed while the claim was still on its way, so the offer never shows: "closed"
  //   - a phone number given: nothing; if the call fails, the offer counts as open again
  // Once per page. Not after emailNowMaxMs (15 min) from the claim: by then the main list's welcome flow, which waits
  // 20 minutes and skips anyone on the second list, sends it. emailNow off: none of this runs.
  var mailClaimAt = 0, mailOffer = false, mailSent = false;
  function emailClaimed(lead) {
    if (!CFG.emailNow || mailSent) return;
    mailClaimAt = Date.now();
    mailOffer = lead.tier === "winner" && FEATURES.phoneUpgrade === true;   // the game shows the offer to exactly these
    if (!mailOffer) emailNow("no_offer");
    else if (!open_) emailNow("closed");   // closed while "Claiming..." was showing: the offer never comes up
  }
  function emailNow(reason, keep) {
    mailOffer = false;
    if (!CFG.emailNow || mailSent || !lastLead || !CFG.klaviyoCompany || !CFG.klaviyoList) return;
    if (Date.now() - mailClaimAt > CFG.emailNowMaxMs) { log("email now: too late, the welcome flow sends it"); return; }
    mailSent = true;
    emit("email_now", { reason: reason });
    var profile = { email: lastLead.email, properties: { tirtir_popup_email_now: reason } };
    if (lastLead.consent) profile.subscriptions = { email: { marketing: { consent: "SUBSCRIBED" } } };
    klaviyo("subscriptions", { data: { type: "subscription", attributes: {
      custom_source: CFG.source,
      profile: { data: { type: "profile", attributes: profile } }
    }, relationships: { list: { data: { type: "list", id: CFG.emailNowList } } } } },
      function (err) { log("email now (" + reason + ") sent:", !err); }, keep === true);
  }
  // Phones rarely fire pagehide: switching app, locking the screen or closing an in-app browser only hides the page and
  // then freezes it, so a hidden page with the offer still open counts as left too (review, 16 Oct 2026). Someone who
  // comes back and then gives a number gets both, as after a close.
  window.addEventListener("pagehide", function () { if (mailOffer) emailNow("left", true); });
  document.addEventListener("visibilitychange", function () { if (mailOffer && document.visibilityState === "hidden") emailNow("left", true); });

  // Phone number step. The game shows TIRTIR's SMS consent paragraph right under the button, so the
  // number joins the SMS list (klaviyoSmsList) with SMS marketing consent; the list's flow texts
  // the code. Without an SMS list the number is only saved on the profile, with no consent.
  function savePhone(phone, cb) {
    if (!CFG.klaviyoCompany || !CFG.klaviyoList) { log("KLAVIYO NOT CONFIGURED - would text the code to:", phone); return cb(null, { simulated: true }); }
    var attrs = { phone_number: phone, properties: { tirtir_popup_text_requested: true } };
    if (FEATURES.phoneUpgrade) attrs.properties.tirtir_popup_discount = FEATURES.upgradePercent;   // the flow sends the upgraded code
    if (SMS_AB && FEATURES.smsOffer) { attrs.properties.tirtir_popup_sms_ab = FEATURES.smsOffer.variant; attrs.properties.tirtir_popup_sms_offer = smsLabel(); attrs.properties.tirtir_popup_sms_ab_at = smsAt(); }   // SMS test: which code the flow sends
    if (lastLead) attrs.email = lastLead.email;
    if (!CFG.klaviyoSmsList) { klaviyo("profiles", { data: { type: "profile", attributes: attrs } }, cb); return; }
    attrs.subscriptions = { sms: { marketing: { consent: "SUBSCRIBED" } } };
    klaviyo("subscriptions", { data: { type: "subscription", attributes: {
      custom_source: CFG.source,
      profile: { data: { type: "profile", attributes: attrs } }
    }, relationships: { list: { data: { type: "list", id: CFG.klaviyoSmsList } } } } }, cb);
  }

  window.addEventListener("message", function (ev) {
    var d = ev.data;
    if (!d || d.__tirtir !== 1 || !frame || ev.source !== frame.contentWindow) return;
    if (d.type === "tirtir:ready")  { ready = true; log("game ready"); reveal(); return; }
    if (d.type === "tirtir:close")  { close("game"); return; }
    if (d.type === "tirtir:upgrade") {
      var st = d.state === "upgraded" || d.state === "declined" ? d.state : null;
      if (st && FEATURES.phoneUpgrade) { if (lastWinMs) saveResult(lastWinMs, true, st); emit("upgrade", { state: st }); }
      if (st === "declined" && mailOffer) emailNow("declined"); else if (st === "upgraded") mailOffer = false;
      return;
    }
    if (d.type === "tirtir:phone" && !(FEATURES.phoneStep || FEATURES.phoneUpgrade)) { send({ type: "tirtir:phone:result", id: d.id, ok: false }); return; }
    if (d.type === "tirtir:phone") {
      var phone = String(d.phone || "").replace(/[\s().-]/g, "");
      if (!(FEATURES.phoneUpgrade ? /^\+1[2-9]\d{2}[2-9]\d{6}$/ : /^\+[1-9]\d{7,14}$/).test(phone)) { send({ type: "tirtir:phone:result", id: d.id, ok: false }); return; }
      emit("phone", { tier: word(d.rewardTier) });
      var offerWas = mailOffer; mailOffer = false;   // emailNow: a number on its way, no 10% email
      savePhone(phone, function (err, res) {
        if (err && offerWas && !mailSent) { if (open_) mailOffer = true; else emailNow("closed"); }
        if (!err && CFG.smsLive && !(res && res.simulated) && !upgradedBefore()) { count(["phone"]); if (smsStep("phone")) count([smsStep("phone")]); }
        send({ type: "tirtir:phone:result", id: d.id, ok: !err, simulated: !CFG.smsLive || !!(res && res.simulated) });
      });
      return;
    }
    if (d.type === "tirtir:sample") { var gift = String(d.giftId || ""); if (FEATURES.sampleGame && /^[a-z0-9-]{1,40}$/.test(gift)) saveSample(gift); return; }
    if (d.type === "tirtir:result") { if (!triedSeen) { triedSeen = true; count(["tried"]); } count(d.outcome === "won" && !wonHere ? ["round", "won"] : ["round"]); if (d.outcome === "won") { wonHere = true; lastWinMs = Number(d.elapsedMs) || 0; saveResult(lastWinMs, false); } log("result:", d.outcome, d.elapsedMs); emit("result", { outcome: word(d.outcome), elapsedMs: typeof d.elapsedMs === "number" ? d.elapsedMs : null }); return; }
    if (d.type === "tirtir:lead") {
      var email = String(d.email || "").trim();
      if (!EMAIL_RE.test(email) || email.length > 254) { send({ type: "tirtir:lead:result", id: d.id, ok: false }); return; }
      var lead = { email: email, consent: d.marketingConsent === true, tier: d.rewardTier || null };
      log("lead: consent:", lead.consent, "tier:", lead.tier);
      emit("lead", { consent: lead.consent, tier: word(lead.tier) });   // never the address: other scripts on the page can read the dataLayer and these events
      subscribe(lead, function (err, res) {
        if (!err && !get(K_WON) && !(res && res.simulated)) count([lead.tier === "winner" ? "email" : "email_nowin"]);
        if (!err) { claimedHere = true; lastLead = lead; set(K_WON, "1"); if (lead.tier === "winner" && lastWinMs) saveResult(lastWinMs, true); if (!open_ && tab && tabAllowed(false)) showTab(); }
        if (!err && SMS_AB && lead.tier === "winner" && !FEATURES.smsOffer) smsGive(smsVersion(true, lead.email));   // SMS test: the phone offer comes next, the version is drawn now
        if (!err && !(res && res.simulated)) emailClaimed(lead);
        send({ type: "tirtir:lead:result", id: d.id, ok: !err, simulated: !!(res && res.simulated) });
        emit("subscribed", { ok: !err, detail: res, error: err && String(err) });
      });
    }
  });

  // Goes to the store's dataLayer and to a document event, where any script on the page can read it:
  // nothing personal in here, ever (no email address, no phone number, not in part either).
  // word(): labels from the game (reward tier, outcome) pass only as a short plain token.
  function word(v) { return typeof v === "string" && /^[A-Za-z0-9_-]{1,24}$/.test(v) ? v : null; }
  function emit(name, detail) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: "tirtir_popup_" + name, detail: detail }); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent("tirtir:popup:" + name, { detail: detail })); } catch (e) {}
  }

  function boot() {
    css();
    try { console.info("%c" + BUILT_BY, "color:#a7342d"); } catch (e) {}
    window.TirtirPopup = {
      builtBy: BUILT_BY,
      open: function () { open("manual"); },
      close: function () { close("manual"); },
      reset: function () { try { localStorage.removeItem(K_DISMISS); localStorage.removeItem(K_WON); sessionStorage.removeItem(K_SHOWN); sessionStorage.removeItem(K_CHAL); sessionStorage.removeItem(K_RESULT); sessionStorage.removeItem(K_CLOSES); } catch (e) {} log("state reset"); },
      state: function () { return { version: VERSION, features: FEATURES, open: open_, ready: ready, dismissedUntil: get(K_DISMISS), won: get(K_WON), blocked: blocked(), cfg: CFG }; }
    };
    var why = blocked();
    if (why) { log("not showing:", why); return; }
    if (!shouldAutoShow()) { if (tabAllowed(true)) showTab(); return; }
    // A shared challenge link (?beatMs=) came to play: open at the minimum delay.
    var challenge = FEATURES.beatMs && !challengeSeen();
    var wait = challenge ? CFG.minDelayMs : Math.max(CFG.minDelayMs, CFG.delayMs);
    var early = !challenge && (CFG.scrollPercent || CFG.exitIntent);
    log("version", VERSION, FEATURES, "- opening in", wait, "ms", early ? { scrollPercent: CFG.scrollPercent, exitIntent: CFG.exitIntent } : "");
    var fired = false, started = 0, timer = null, startY = 0, scrolled = false, interacted = false;
    var INPUTS = ["wheel", "touchmove", "keydown", "mousedown"];   // the visitor scrolling (browser jumps to an anchor or a restored position do not count)
    function touched() { interacted = true; }
    // Shopify's cookie banner: the pop-up waits until the visitor has answered it (then a short moment more), but not
    // for ever. After wait + 12 s it opens anyway, above the banner (the banner is not modal and sits below the pop-up).
    // With waitForConsent false none of this applies.
    var consentAnswered = false, settleUntil = 0;
    if (CFG.waitForConsent) document.addEventListener("visitorConsentCollected", function () { consentAnswered = true; settleUntil = Date.now() + 1500; });
    function shown(id) { var el = document.getElementById(id); if (!el || !el.getClientRects().length) return false; var cs = window.getComputedStyle(el); return cs.display !== "none" && cs.visibility !== "hidden" && cs.opacity !== "0"; }
    function covered() {
      if (themeLocked() || cartBusy()) return true;        // cart drawer, menu, filters or quick-add (Broadcast), or an add to cart on its way
      if (CFG.waitForPanels && appPanel()) return true;    // chat, Rewards, gift offers, shade finder, waitFor
      if (!CFG.waitForConsent) return false;                // the cookie banner does not hold it back
      if (Date.now() < settleUntil) return true;
      if (consentAnswered || Date.now() - started >= wait + 12000) return false;
      if (shown("shopify-pc__banner") || shown("shopify-pc__prefs__dialog")) return true;
      // Banner still to come for a visitor who has not answered yet (Shopify's own test: region flag AND no answer).
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy, vc = cp && typeof cp.currentVisitorConsent === "function" ? cp.currentVisitorConsent() : null;
        if (vc && vc.marketing === "" && vc.analytics === "" && vc.preferences === "" && typeof cp.shouldShowBanner === "function" && cp.shouldShowBanner()) return true;
      } catch (e) {}
      return false;
    }
    function stop() {
      fired = true; clearTimeout(timer);
      window.removeEventListener("scroll", onScroll); document.removeEventListener("mouseout", onLeave);
      INPUTS.forEach(function (t) { window.removeEventListener(t, touched, true); });
    }
    function fire(reason) {
      if (fired) return;
      // Never on top of the theme's open cart drawer, menu, filters or quick-add, or an add to cart on its way; with waitForPanels not on an open app panel; with waitForConsent not on the cookie banner.
      if (covered()) {
        if (reason === "timer") timer = setTimeout(function () { fire("timer"); }, 1000);   // scroll and exit stay armed too
        return;
      }
      stop();
      if (shouldAutoShow()) open(reason, true); else if (tabAllowed(true)) showTab();
    }
    autoCovered = covered;
    document.addEventListener("click", cartTap, { passive: true, capture: true });
    document.addEventListener("submit", cartTap, { passive: true, capture: true });
    function onScroll(e) {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (!interacted) { startY = y; return; }               // only the visitor's own scrolling counts, not a page that opened part-way down
      if (e && Math.abs(y - startY) > 10) scrolled = true;
      if (!scrolled || Date.now() - started < CFG.minDelayMs) return;
      var range = Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0) - window.innerHeight;
      // scrollPercent of the page, or two screens down on long pages, whichever comes first
      if (range > 0 && y >= Math.min(range * CFG.scrollPercent / 100, 2 * window.innerHeight)) fire("scroll");
    }
    function onLeave(e) { if (Date.now() - started >= CFG.minDelayMs && !e.relatedTarget && e.clientY <= 0) fire("exit"); }
    // The clock starts when the visitor can see the tab (not in a background tab opened with cmd/ctrl-click).
    function arm() {
      started = Date.now(); startY = window.pageYOffset || document.documentElement.scrollTop || 0;
      // Warm the game file during the wait so the pop-up opens on time: after the page's own images, ready before the earliest open.
      setTimeout(function () { loadGame().catch(function () {}); }, early ? Math.max(0, CFG.minDelayMs - 500) : Math.max(0, wait - 2500));
      timer = setTimeout(function () { fire("timer"); }, wait);
      if (!early) return;
      if (CFG.scrollPercent) {
        INPUTS.forEach(function (t) { window.addEventListener(t, touched, { passive: true, capture: true }); });
        window.addEventListener("scroll", onScroll, { passive: true });
        setTimeout(onScroll, CFG.minDelayMs + 50);   // catches someone who scrolled far before minDelayMs
      }   // catches someone who scrolled far before minDelayMs
      if (CFG.exitIntent && window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches) document.addEventListener("mouseout", onLeave);
    }
    if (document.hidden) document.addEventListener("visibilitychange", function shown() { if (!document.hidden) { document.removeEventListener("visibilitychange", shown); arm(); } });
    else arm();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
